// @flow
import * as React from 'react';
import ReactDOM from 'react-dom';
import VenueCollectionContainer from './VenueCollectionContainer';
import type { Venue } from './types';

// $FlowFixMe
const rootElement: HTMLElement = document.getElementById('collection-search');

// $FlowFixMe
// const collectionURL: string = document.body.getAttribute('data-base-url');
const collectionData: Array<Venue> = JSON.parse(
  // $FlowFixMe
  rootElement.getAttribute('data-venues'),
);
// process.env.NODE_ENV === 'production'
//   ? rootElement.getAttribute('data-base-url')
//   : process.env.SEARCH_COLLECTION_URL;

ReactDOM.render(
  <VenueCollectionContainer venues={collectionData} />,
  rootElement,
);
